import { flattenRoutes } from './flattenUrl'

export default [
  {
    path: '/en',
    name: 'Layout',
    component: () => import('@/layout/layout-view'),
    children: [
      {
        path: 'home',
        name: 'HomeView',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: 'Home' },
      },
      {
        path: 'user-index',
        name: 'UserIndex',
        component: () => import('@/views/UserIndex.vue'),
        meta: { title: 'User Info' },
      },
      ...flattenRoutes,
    ],
  },
  {
    path: '/login_EN',
    name: 'LoginView_EN',
    component: () => import('@/views/login3.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/entry',
    name: 'RegisterPerson',
    component: () => import('@/views/registerPerson.vue'),
  },
]
